import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PATHS_DICT, ROUTES_PREFIX } from './auth.routes';
import { CallbackPageComponent } from './pages/callback-page.component';
import { ErrorPageComponent } from './pages/error-page.component';
import { LoginPageComponent } from './pages/login-page.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: ROUTES_PREFIX,
        children: [
          {
            path: PATHS_DICT.CALLBACK,
            component: CallbackPageComponent
          },
          {
            path: PATHS_DICT.ERROR,
            component: ErrorPageComponent
          },
          {
            path: PATHS_DICT.LOGIN,
            component: LoginPageComponent
          }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
